import NotificationService from '../../domain/services/NotificationService';

export { NotificationService };
export default NotificationService;
